import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

hydrateRoot(
  document.getElementById("root"),
  <BrowserRouter>
    <HelmetProvider>
      <App
        initialData={window.__INITIAL_DATA__}
        initialSeo={window.__INITIAL_SEO__}
        initialSchema={window.__INITIAL_SCHEMA__}
      />
    </HelmetProvider>
  </BrowserRouter>
);


reportWebVitals();
